"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 16 16" id=icon-chevron-up-extra-small><path d="M12.194 9.691a.625.625 0 0 1-.881 0L8 6.38 4.694 9.69a.628.628 0 1 1-.888-.887l3.75-3.75a.625.625 0 0 1 .882 0l3.75 3.75a.625.625 0 0 1 .006.887Z"></path></symbol>';
}